module.exports = __webpack_public_path__ + "img/svijetlece-reklame.8fb940e4.jpg";